// 設定の画面の「Zoomアカウント」欄に出す内容（NP-USR-FEAT-007）。
// 以前は Zoom のユーザー ID を出していて、どの Zoom アカウントか見分けにくかった。
// この端末の種類（push_target: 0 = iOS、1 = Android）の Zoom のメールを出す。

export const PUSH_TARGET_IOS = 0
export const PUSH_TARGET_ANDROID = 1

function present (value) {
  return typeof value === 'string' && value.length > 0
}

export function zoomConnected (user, pushTarget) {
  if (!user) return false
  if (pushTarget === PUSH_TARGET_IOS) return Boolean(user.ios_zoom_available)
  if (pushTarget === PUSH_TARGET_ANDROID) return Boolean(user.android_zoom_available)
  return false
}

// { label, value } を返す。
// メールが無いとき（メールを返さない古いサーバーなど）は、以前どおり ID を出す。
export function zoomAccountDisplay (user, pushTarget) {
  if (!zoomConnected(user, pushTarget)) {
    return { label: 'メールアドレス', value: 'Zoomと連携していません' }
  }
  const emails = pushTarget === PUSH_TARGET_ANDROID
    ? [user.android_zoom_email, user.ios_zoom_email]
    : [user.ios_zoom_email, user.android_zoom_email]
  const email = emails.find(present)
  if (email) {
    return { label: 'メールアドレス', value: email }
  }
  return { label: 'ID', value: present(user.zoom_id) ? user.zoom_id : '' }
}
